import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from '../../../styles/blocks/image.module.scss';

const propTypes = {
    image: PropTypes.shape({
        url: PropTypes.string,
        centered: PropTypes.bool,
    }),
    className: PropTypes.string,
};

const defaultProps = {
    image: null,
    className: null,
};

const ImageBlock = ({ image, className }) => {
    return image ? (
        <div
            className={classNames([
                styles.container,
                { [styles.centered]: image.centered, [className]: className !== null },
            ])}
        >
            {image && image.url ? (
                <img className={styles.image} src={image.url} alt="Block" />
            ) : null}
        </div>
    ) : null;
};

ImageBlock.propTypes = propTypes;
ImageBlock.defaultProps = defaultProps;

export default ImageBlock;
